function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A8BDE",
  fillRule: "evenodd",
  d: "M11.378.233h.528C17.723.51 22.458 5.244 22.71 11.087a11.321 11.321 0 0 1-11.23 11.785H6.34a6.298 6.298 0 0 1-6.295-6.296v-5.338C.222 5.118 5.233.233 11.378.233zm-.454 6.522c0 .353.126.605.353.781.252.201.554.302.906.302.378 0 .705-.1.932-.302.227-.176.353-.453.353-.78 0-.353-.126-.63-.353-.832-.227-.201-.529-.302-.932-.302-.377 0-.68.1-.906.302-.227.202-.353.479-.353.831zm-1.31 3.5l.983.227-1.058 4.81c-.05.252-.1.453-.126.655-.025.201-.05.403-.05.604a.71.71 0 0 0 .227.503c.15.152.403.227.805.227.177 0 .378-.025.58-.05.201-.025.403-.076.604-.151.201-.076.403-.151.579-.227.176-.1.353-.176.479-.277v-.554h-1.083l1.41-6.673-.277-.176c-.227 0-.478.025-.755.05-.278.025-.554.076-.857.126-.302.05-.579.1-.83.176-.278.076-.479.151-.63.202v.529z"
});

const SvgInfo = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info.3ee44e42.svg";
export { ForwardRef as ReactComponent };